import { logoutUser } from './user.api';

export async function logoutConnectedUser() {
  try {
    await logoutUser();
    if (window.Intercom) {
      window.Intercom('shutdown'); // Clear Intercom conversations on client side
    }
    if (window.FS) {
      window.FS.clearUserCookie(); // Clear FullStory user identification
    }
    window.location.reload();
  } catch {
    console.log('Error in logout');
  }
}
